export default __webpack_public_path__ + "static/media/Armbands of Erlik.530d2937.jpg";